import React, {useCallback, useEffect, useReducer, useRef, useState} from 'react'
import Loading from "components/Loading";
import {Collapse} from "@material-ui/core";
import Tr from "translations/Translations";
import iconWorksReducer from "libs/iconWorksReducer";
import Section from "pages/purchaser/MyProcedure/scenes/part2/components/Section";
import AnnualReportsService from "services/AnnualReportsService";
import annualReportSteps, {annualReportTablesWithInitialize} from "./constants/annualReportSteps";
import Page from "components/Page";
import {useParams} from "react-router";
import annulaReportClasses from "./constants/annulaReportClasses";
import {connect} from "react-redux";
import FormTranslationContext from "context/FormTranslationContext";
import useSnackbar from "hooks/useSnackbar";
import useEzamowieniaOauth from "hooks/useEzamowieniaOauth";
import AnnualReportNavigator from "./components/common/AnnualReportNavigator";
import AnnualReportPurchaserForm from "./components/purchaser/AnnualReportPurchaserForm";
import AnnualReportAboveEuForm from "./components/aboveEu/AnnualReportAboveEuForm";
import AnnualReportBelowEuForm from "./components/belowEu/AnnualReportBelowEuForm";
import AnnualReportConflictForm from "./components/conflict/AnnualReportConflictForm";
import AnnualReportCommunityForm from "./components/community/AnnualReportCommunityForm";
import AnnualReportSocialForm from "./components/social/AnnualReportSocialForm";
import AnnualReportInnovativeForm from "./components/innovative/AnnualReportInnovativeForm";
import AnnualReportExceptionForm from "./components/exception/AnnualReportExceptionForm";
import AnnualReportNotIncludedForm from "./components/notIncluded/AnnualReportNotIncludedForm";
import dictToTranslationMap from "./constants/dictToTranslationMap";
import Typography from "components/Typography";
import AnnualReportStatus, {annualReportStatusTr} from "./constants/AnnualReportStatus";
import BoldTypography from "components/BoldTypography";
import scrollTo from "libs/scrollTo";
import RouterPath from "libs/RouterPath";
import Button from "components/Button";
import GridBlock from "components/GridBlock";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import AnnualReportError from "./components/common/AnnualReportError";
import isResponseValid from "libs/isResponseValid";
import ReloadAnnualReportTableFromPrevVersionButton from "./components/common/ReloadAnnualReportTableFromPrevVersionButton";
import ReloadAnnualReportTableButton from "./components/common/ReloadAnnualReportTableButton";
import EZamowieniaIcon from "components/icon/EZamowieniaIcon";
import previewFile from "libs/previewFile";
import WorkableButton from "components/button/WorkableButton";
import {alertComplex} from "libs/AlertNotification";
import {MMiA_REQUIRED_GROUPS} from "constants/EzamowieniaRequiredGroups";

function getKey(id) {
    const split = id.split(".").filter(x => !/^\d+$/.test(x));
    return split.join(".");
}

const empty_object = {};

function AnnualReportPage(
    {
        initFormValues = empty_object,
        initData
    }) {
    const classes = annulaReportClasses();
    const params = useParams();
    const currentForm = useRef(null);
    const [dictionaries, setDictionaries] = useState(null);
    const [translations, setTranslations] = useState(null);
    const [dictTranslations, setDictTranslations] = useState(null)
    const {authorizeEzamowienia} = useEzamowieniaOauth();
    const {enqueueInfoSnackbar, enqueueSuccessSnackbar, enqueueErrorSnackbar} = useSnackbar();
    const setFrom = (form) => {
        currentForm.current = form;
    }
    const setCurStep = useCallback(newStep =>
        RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.annualReport.MP_ANNUAL_REPORT_REPORT_ID_TABLE, {
            id: params.id,
            table: newStep
        })), [params.id]);
    const backToList = () => RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.annualReport.MP_ANNUAL_REPORT_YEAR_LIST, {year: initData.year}));

    const [buttonWorks, dispatchButtonWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        ezamowienia: false,
        loading: false,
        pdf: false
    });
    const disabled = !initData || !initData.hasEdit || buttonWorks.anyWorks

    const formTr = useCallback((id) => {
        const key = getKey(id);
        return translations.labels[key] || key;
    }, [translations])
    const formTip = useCallback((id) => {
        const key = getKey(id);
        return translations.tips[key];
    }, [translations]);

    const getDict = useCallback((id) => {
        try {
            return dictionaries[id].items;
        } catch (e) {
            console.error("DictId: " + id)
            console.error(e)
        }
    }, [dictionaries])

    useEffect(() => {
        Promise.all([
            AnnualReportsService.getAnnualReport(params.id),
            AnnualReportsService.getAnnualReportDictionaries(),
            AnnualReportsService.getAnnualReportTranslations()])
            .then(values => {
                const dictTr = values[1] ? {
                    type: dictToTranslationMap(values[1]["MP.MMiA.OrdersType"].items, true),
                    procedures: dictToTranslationMap(values[1]["MP.MMiA.BelowEU.procedure"].items, true),
                    source: dictToTranslationMap(values[1]["MP.MMiA.Source"].items, false),
                    orderType: dictToTranslationMap(values[1]["ENUM.002"].items, true),
                    tenderModeTed: dictToTranslationMap(values[1]["ENUM.018_019_TED"].items, false),
                    tenderModeBzp: dictToTranslationMap(values[1]["ENUM.018_019_BZP"].items, false),
                    contractorCountryList: dictToTranslationMap(values[1]["SL.MT.005"].items, true),
                    contractorType: dictToTranslationMap(values[1]["SL.MMiA.062"].items, false),
                    exceptions: dictToTranslationMap(values[1]["SL.MMiA.063"].items, false),
                    notIncluded: dictToTranslationMap(values[1]["SL.MMiA.064"].items, false),
                } : null
                setDictionaries(values[1]);
                setTranslations(values[2]);
                setDictTranslations(dictTr)
            })
        return () => {
            AnnualReportsService.clearResources(AnnualReportsService.ANNUAL_REPORT_TABLES_RESOURCE_ID)
            AnnualReportsService.clearResources(AnnualReportsService.ANNUAL_REPORT_RESOURCE_ID)
        }
    }, [params.id])

    useEffect(() => {
        if (!params.table) {
            setCurStep(annualReportSteps.purchaser)
        } else if (!initFormValues[params.table]) {
            dispatchButtonWorks({type: "loading", works: true});
            AnnualReportsService.getAnnualReportFormValues(params.id, params.table).finally(() => {
                dispatchButtonWorks({type: "loading", works: false});
            })
        }
    }, [params.id, params.table, initFormValues, setCurStep])

    const onCurStepChange = (newStep) => {
        (async () => {
            const dirty = currentForm.current?.dirty;
            if (dirty) {
                enqueueInfoSnackbar(Tr("save_changes_to_go"))
            } else {
                setFrom(null)
                setCurStep(newStep)
            }
        })()
    }

    const submitInEzamowienia = () => {
        dispatchButtonWorks({type: "ezamowienia", works: true});
        authorizeEzamowienia(
            () => {
                AnnualReportsService.submitAnnualReportToEzamowienia(params.id).then((resp) => {
                    if (resp) {
                        if (isResponseValid(resp, enqueueErrorSnackbar)) {
                            enqueueSuccessSnackbar(Tr("annual_report_submited_to_ezamowienia"))
                        }
                    }
                    dispatchButtonWorks({type: "ezamowienia", works: false});
                })
            },
            () => {
                dispatchButtonWorks({type: "ezamowienia", works: false});
            },
            MMiA_REQUIRED_GROUPS)
    }
    const sendToEzamowienia = () => {
        dispatchButtonWorks({type: "ezamowienia", works: true});
        authorizeEzamowienia(
            () => {
                AnnualReportsService.sendAnnualReportToEzamowienia(params.id).then((resp) => {
                    if (resp && resp.success) {
                        enqueueSuccessSnackbar(Tr("annual_report_sent_to_ezamowienia"))
                    } else if (resp) {
                        const errors = resp.errors;
                        if (Array.isArray(errors)) {
                            if (errors.length > 0)
                                enqueueErrorSnackbar(errors[0]);
                        } else if (typeof errors === 'object' && errors !== null) {
                            const keys = Object.keys(errors);
                            if (keys.length > 0) {
                                const key = keys[0];
                                enqueueErrorSnackbar(errors[key]);
                                if (annualReportSteps.hasOwnProperty(key)) {
                                    setCurStep(key);
                                    setTimeout(() => scrollTo("." + classes.sectionErrorIcon, 200), 200)
                                }
                            }
                        }
                    }
                    dispatchButtonWorks({type: "ezamowienia", works: false});
                })
            },
            () => {
                dispatchButtonWorks({type: "ezamowienia", works: false});
            },
            MMiA_REQUIRED_GROUPS
        )
    }
    const downloadPdf = () => {
        dispatchButtonWorks({type: "pdf", works: true});
        authorizeEzamowienia(
            () => {
                AnnualReportsService.downloadAnnualReportPdfFromEzamowienia(params.id).finally(() => dispatchButtonWorks({type: "pdf", works: false}))
            },
            () => {
                dispatchButtonWorks({type: "pdf", works: false});
            },
            MMiA_REQUIRED_GROUPS
        )
    }

    if (!initData || !translations || !dictionaries || !dictTranslations) return <Loading/>
    return (
        <Page className={classes.root}>
            <GridBlock justify="space-between" className={classes.marginBottom}>
                <Button className={classes.back} variant="outlined" Icon={ArrowBackIosIcon} onClick={backToList}>{Tr("back_to_list")}</Button>
                <div>
                    <BoldTypography
                        variant="h5">{`${Tr('annual_reports')} ${initData.year} ${Tr('version').toLowerCase()} ${initData.version}`}</BoldTypography>
                    {!!initData.ezamowieniaNumber && <Typography>{Tr("annual_report_number") + ": " + initData.ezamowieniaNumber}</Typography>}
                </div>
                <div>
                    {
                        [AnnualReportStatus.SENT, AnnualReportStatus.APPROVED, AnnualReportStatus.APPROVED_MODIFIED].includes(initData.status) &&
                        <WorkableButton Icon={EZamowieniaIcon} disabled={buttonWorks.anyWorks} working={buttonWorks.pdf} variant="outlined"
                                        onClick={downloadPdf}>
                            {Tr("annual_report_download_pdf")}
                        </WorkableButton>
                    }
                </div>
            </GridBlock>
            <Section>
                <FormTranslationContext.Provider value={{
                    formTr, formTip, getDict, dictTranslations
                }}>
                    <AnnualReportError report={initData}/>


                    <Typography variant="body2" align='right'><strong>{Tr('current_state')}:</strong> {annualReportStatusTr(initData.status)}
                    </Typography>
                    <AnnualReportNavigator
                        formTr={formTr}
                        disabled={disabled}
                        buttonWorks={buttonWorks}
                        curStep={params.table}
                        onCurStepChange={onCurStepChange}
                        onSendToEzamowienia={AnnualReportStatus.DRAFT === initData.status && sendToEzamowienia}
                        onSubmitInEzamowienia={AnnualReportStatus.SENT === initData.status && submitInEzamowienia}
                    />
                    <Collapse in={params.table === annualReportSteps.purchaser} unmountOnExit>
                        <AnnualReportPurchaserForm
                            initValues={initFormValues[annualReportSteps.purchaser]}
                            disabled={disabled}
                            classes={classes}
                            setFrom={setFrom}
                        />
                    </Collapse>
                    <Collapse in={params.table === annualReportSteps.belowEu} unmountOnExit>
                        <AnnualReportBelowEuForm
                            initValues={initFormValues[annualReportSteps.belowEu]}
                            disabled={disabled}
                            classes={classes}
                        />
                    </Collapse>
                    <Collapse in={params.table === annualReportSteps.aboveEu} unmountOnExit>
                        <AnnualReportAboveEuForm
                            initValues={initFormValues[annualReportSteps.aboveEu]}
                            disabled={disabled}
                            classes={classes}
                        />
                    </Collapse>
                    <Collapse in={params.table === annualReportSteps.conflict} unmountOnExit>
                        <AnnualReportConflictForm
                            initValues={initFormValues[annualReportSteps.conflict]}
                            disabled={disabled}
                            classes={classes}
                        />
                    </Collapse>
                    <Collapse in={params.table === annualReportSteps.community} unmountOnExit>
                        <AnnualReportCommunityForm
                            initValues={initFormValues[annualReportSteps.community]}
                            disabled={disabled}
                            classes={classes}
                        />
                    </Collapse>
                    <Collapse in={params.table === annualReportSteps.social} unmountOnExit>
                        <AnnualReportSocialForm
                            initValues={initFormValues[annualReportSteps.social]}
                            disabled={disabled}
                            classes={classes}
                        />
                    </Collapse>
                    <Collapse in={params.table === annualReportSteps.innovative} unmountOnExit>
                        <AnnualReportInnovativeForm
                            initValues={initFormValues[annualReportSteps.innovative]}
                            disabled={disabled}
                            classes={classes}
                        />
                    </Collapse>
                    <Collapse in={params.table === annualReportSteps.exception} unmountOnExit>
                        <AnnualReportExceptionForm
                            initValues={initFormValues[annualReportSteps.exception]}
                            disabled={disabled}
                            classes={classes}
                        />
                    </Collapse>
                    <Collapse in={params.table === annualReportSteps.notIncluded} unmountOnExit>
                        <AnnualReportNotIncludedForm
                            initValues={initFormValues[annualReportSteps.notIncluded]}
                            disabled={disabled}
                            classes={classes}
                        />
                    </Collapse>

                    {
                        params.table && <GridBlock className={classes.marginTop}>
                            {initData.hasEdit && annualReportTablesWithInitialize.includes(params.table) &&
                                <ReloadAnnualReportTableButton classes={classes} disabled={disabled} reportStep={params.table}/>
                            }

                            {
                                initData.hasEdit && initData.version > 1 &&
                                <ReloadAnnualReportTableFromPrevVersionButton classes={classes} disabled={disabled} reportStep={params.table}/>
                            }
                            {
                                [AnnualReportStatus.SENT, AnnualReportStatus.APPROVED, AnnualReportStatus.APPROVED_MODIFIED].includes(initData.status) &&

                                <Button variant="outlined" Icon={EZamowieniaIcon}
                                        onClick={() => alertComplex({
                                            confirmText: "annual_report_preview_in_ezamowienia_confirm", onClose: () => previewFile({url: initData.previewUrl}),
                                            buttonText: Tr("go")
                                        })
                                        }>
                                    {Tr("annual_report_preview_in_ezamowienia")}
                                </Button>
                            }
                        </GridBlock>
                    }
                </FormTranslationContext.Provider>
            </Section>
        </Page>
    )
}

AnnualReportPage.propTypes = {};

export default connect((state) => ({
    initFormValues: state.resources[AnnualReportsService.ANNUAL_REPORT_TABLES_RESOURCE_ID],
    initData: state.resources[AnnualReportsService.ANNUAL_REPORT_RESOURCE_ID],
}))(AnnualReportPage);
